export const adminConstants = {

    GET_DAY_ATTENDANCE: 'GET_DAY_ATTENDANCE'
    
};